import type { SlideDef } from "@/engine/types";
import { TitleSlide } from "./01-title";
import { AgendaSlide } from "./02-agenda";
import { AuthoritySlide } from "./03-authority";
import { DurableAuthoritySlide } from "./04-durable-authority";
import { TrustRisksSlide } from "./05-trust-risks";

export const slides: SlideDef[] = [
  { id: "c1-title", chapter: 1, title: "Title", component: TitleSlide },
  { id: "c1-agenda", chapter: 1, title: "What we'll cover", component: AgendaSlide },
  {
    id: "c1-authority",
    chapter: 1,
    title: "Page authority and site strength",
    component: AuthoritySlide,
  },
  {
    id: "c1-durable-authority",
    chapter: 1,
    title: "Building authority the durable way",
    component: DurableAuthoritySlide,
  },
  {
    id: "c1-trust-risks",
    chapter: 1,
    title: "What can hurt trust and rankings",
    component: TrustRisksSlide,
  },
];
